import { render, staticRenderFns } from "./zc-app.vue?vue&type=template&id=2cce1cb6"
import script from "./zc-app.vue?vue&type=script&lang=js"
export * from "./zc-app.vue?vue&type=script&lang=js"
import style0 from "./zc-app.vue?vue&type=style&index=0&id=2cce1cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports